<svg #chart id="year-overview-chart" [style.width]="'420px'"></svg>

<div
    id="tooltip"
    class="__tooltip u-flex u-flex-justify-content-center u-flex-align-items-center u-text-align-center u-position-absolute u-background-white"
    style="opacity: 0"
>
    <div id="tooltip-value"></div>
</div>
